<div>
  <div class="sub-page">
    <h1 translate>About</h1>

    <section>
      <h2>
        ViveSec Webapp <span>v{{ version }}</span> <span *ngIf="!environmentService.production">dev</span><span *ngIf="environmentService.production && environmentService.beta">beta</span>
      </h2>
      <p *ngIf="appInfo">Build: {{ appInfo.build }}</p>
      <p>Copyright (c) 2021-2026 Clarabot Zrt.</p>
      <p translate>This software is part of a proprietary project and must not be distributed, modified or used in any way without explicit permission from the owner.</p>
    </section>
    <section>
      <h2 translate>Used software</h2>
      <mat-divider></mat-divider>
      <div>
        <div class="lib">
          <p>Postal code city data from <a href="https://www.geonames.org" target="_blank">www.geonames.org</a></p>
          <p>CC BY 4.0</p>
        </div>
      </div>
      <mat-divider></mat-divider>
      <div *ngFor="let lib of data">
        <div class="lib">
          <p>
            {{ lib.publisher ? lib.publisher + ' -' : '' }} {{ lib.name }}
            <a href="{{ lib.repository }}" class="mdi mdi-github" target="_blank"></a>
          </p>
          <p>{{ lib.licenses }}</p>
        </div>
        <mat-divider></mat-divider>
      </div>
    </section>

    <section translate>Sounds from <a href="https://notificationsounds.com/" target="_blank" translate>Notification Sounds</a></section>
  </div>
</div>
